export enum TrimAroundPorch {
  None = 'none',
  CornerTrimOnly = 'corner-trim-only',
  FrontGableTrimOnly = 'front-gable-trim-only',
  CornerTrimPlusFrontGableTrim = 'corner-trim-plus-front-gable-trim',
}
